export const SDK_CSS = `
.woot-widget-holder {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 5px 40px;
  opacity: 1;
  overflow: hidden !important;
  position: fixed !important;
  transition-duration: 0.5s, 0.5s;
  transition-property: opacity, bottom;
  transition-timing-function: ease-in-out;
  z-index: 2147483647;
}

.woot-widget-holder iframe {
  border: 0;
  height: 100% !important;
  width: 100% !important;
}

.woot--bubble-holder {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 16px;
  z-index: 2147483647;
}

.woot-widget-bubble {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  height: 48px;
  width: 48px;
  position: relative;
  user-select: none;
  filter: drop-shadow(0px 1px 4px rgba(0,0,0,0.2));
  transition: 0.3s;
  animation: widget-animation 0.5s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.woot-widget-bubble:active {
  transform: scale(1)
}

.woot--bubble-holder.woot-elements--left {
  left: 16px;
  align-items: flex-start;
}

.woot--bubble-holder.woot-elements--right {
  align-items: flex-end;
  right: 16px;
}

.woot-widget-bubble:hover, .lime-first-time-popup:hover {
  filter: drop-shadow(0px 1px 8px rgba(0,0,0,0.4));
  transform: scale(1.02)
}

.woot-widget-bubble img {
  transition: initial! important;
  opacity: 1 !important;
  width: 100%;
  height: 100%;
}

@media only screen and (min-width: 667px) {
  .woot-widget-holder.woot-elements--left {
    left: 16px;
  }
  .woot-widget-holder.woot-elements--right {
    right: 16px;
  }
}

.woot-widget-bubble.woot-widget--standard_small {
  height: 40px;
  width: 40px;
}

.woot-widget-bubble.woot-widget--standard_large{
  height: 64px;
  width: 64px;
}

.woot-widget--standard_small,
.woot-widget--standard_medium,
.woot-widget--standard_large{
  box-shadow: none !important;
  border: none;
}

.woot-widget--standard_small.white-background,
.woot-widget--standard_medium.white-background,
.woot-widget--standard_large.white-background{
  background-size: contain;
}

.woot-widget-bubble.woot-widget--standard_large img {
  height: 64px;
  width: 64px;
}

.woot-widget-bubble.woot-widget--expanded_small {
  display: flex;
  align-items: center;
  height: 48px !important;
  width: auto !important;
  border-radius: 140px !important;
}

.woot-widget-bubble.woot-widget--expanded_small div {
  color: #fff;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, Arial, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  padding-right: 8px;
}

.woot-widget-bubble.woot-widget--expanded_small img {
  height: 24px;
  width: 24px;
  margin-right: 4px;
}

.woot-widget-bubble.woot-widget--expanded_medium {
  display: flex;
  align-items: center;
  height: 48px !important;
  width: auto !important;
  border-radius: 140px !important;
}

.woot-widget-bubble.woot-widget--expanded_medium div {
  color: #fff;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, Arial, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  padding-right: 8px;
}

.woot-widget-bubble.woot-widget--expanded_medium img {
  height: 32px;
  width: 32px;
  margin-right: 4px;
}

.woot-widget-bubble.woot-widget--expanded_large {
  display: flex;
  height: 56px !important;
  width: auto !important;
  border-radius: 140px !important;
}

.woot-widget-bubble.woot-widget--expanded_large div {
  color: #fff;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, Arial, sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  justify-content: center;
  padding-right: 8px;
}

.woot-widget-bubble.woot-widget--expanded_large img {
  height: 40px;
  width: 40px;
  margin-right: 4px;
}

.woot--hide {
  bottom: -20000px !important;
  opacity: 0;
  visibility: hidden !important;
  z-index: -1 !important;
}

.woot--show {
  bottom: 0px;
  opacity: 1;
  visibility: visible !important;
  z-index: 1000203109 !important;
}

.woot-widget--without-bubble {
  bottom: 16px !important;
}

.lime-first-time-popup {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  position: absolute;
  font-family: Lato, sans-serif;
  font-size: 14px;
  background-color: #fff;
  border-radius: 12px;
  filter: drop-shadow(0px 1px 4px rgba(0,0,0,0.4));
  width: intrinsic;
  width: -moz-max-content;
  width: -webkit-max-content;
  white-space: pre-wrap;
  color: #1d2129;
  padding: 5px;
  word-break: break-word;
  text-decoration: none;
  max-width: 180px;
  height: auto !important;
  transition: 0.3s;
}

/* Styles for new popup elements */
.lime-first-time-popup .popup-header {
  font-weight: bold;
  margin-bottom: 6px;
  font-size: 15px;
}

.lime-first-time-popup .popup-cta {
  margin-top: 8px;
  width: 100%;
}

.lime-first-time-popup .popup-cta button {
  background-color: #0072f0;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  width: 100%;
  transition: all 0.2s ease;
}

.lime-first-time-popup .popup-cta button:hover {
  background-color: #0062d4;
}

.lime-first-time-popup .popup-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 8px;
  border: 1px solid #e0e0e0;
}

/* Popup type-specific styles */
.lime-first-time-popup.popup-type-promotional {
  background-color: #fefbf3;
  border: 1px solid #f0e1b8;
}

.lime-first-time-popup.popup-type-urgent {
  background-color: #fff0f0;
  border: 1px solid #ffccd0;
}

.lime-first-time-popup.popup-type-informational {
  background-color: #f0f8ff;
  border: 1px solid #cce5ff;
}

.lime-first-time-popup--side-right{
  right: 108%;
  bottom: 2px;
  -webkit-animation: lime-fade-in-right 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
  animation: lime-fade-in-left 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.lime-first-time-popup--side-right-standard_medium{
  right: 124%;
}

.lime-first-time-popup--side-right-standard_small{
  right: 128%;
  bottom: 0;
}

.lime-first-time-popup--side-right-standard_large{
  right: 122%;
  bottom: 10px;
}

.lime-first-time-popup--side-right:after {
    transform: translateX(5px) rotate(45deg);
    box-shadow: rgb(0 0 0 / 20%) 2px -2px 4px 0px;
    display: block;
    position: absolute;
    content: "";
    width: 10px;
    height: 10px;
    bottom: 12px;
    background-color: #fff;
    right: 0;
}

.lime-first-time-popup--top-right{
  right: 0;
  bottom: 125%;
  -webkit-animation: lime-fade-in-bottom 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
  animation: lime-fade-in-bottom 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.lime-first-time-popup--top-right:after {
  transform: translateX(-20px) rotate(45deg);
  box-shadow: rgb(0 0 0 / 20%) 2px 2px 4px 0px;
  display: block;
  position: absolute;
  content: "";
  width: 10px;
  height: 10px;
  bottom: -4px;
  background-color: #fff;
  right: 0;
}

.lime-first-time-popup--top-right-standard_medium{
  right: 0;
}

.lime-first-time-popup--top-right-standard_small{
  right: -5px;
}

.lime-first-time-popup--top-right-standard_large{
  right: 8px;
  bottom: 120%;
}

.lime-first-time-popup--side-left{
  bottom: 2px;
  left: 108%;
  -webkit-animation: lime-fade-in-right 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
  animation: lime-fade-in-right 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.lime-first-time-popup--side-left-standard_medium{
  left: 124%
}

.lime-first-time-popup--side-left-standard_small{
  left: 128%;
  bottom: 0;
}

.lime-first-time-popup--side-left-standard_large{
  left: 122%;
  bottom: 10px;
}

.lime-first-time-popup--side-left:after {
    transform: translateX(-5px) rotate(225deg);
    box-shadow: rgb(0 0 0 / 20%) 2px -2px 4px 0px;
    display: block;
    position: absolute;
    content: "";
    width: 10px;
    height: 10px;
    bottom: 12px;
    background-color: #fff;
    left: 0;
}


.lime-first-time-popup--top-left{
  left: 0;
  bottom: 125%;
  -webkit-animation: lime-fade-in-bottom 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
  animation: lime-fade-in-bottom 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.lime-first-time-popup--top-left:after {
  transform: translateX(-20px) rotate(45deg);
  -webkit-transform: translateX(-145px) rotate(45deg);
  -moz-transform: translateX(-20px) rotate(45deg);
  -o-transform: translateX(-20px) rotate(45deg);
  -ms-transform: translateX(-20px) rotate(45deg);
  -moz-box-shadow: rgb(0 0 0 / 20%) 2px 2px 4px 0px;
  -webkit-box-shadow: rgb(0 0 0 / 20%) 2px 2px 4px 0px;
  box-shadow: rgb(0 0 0 / 20%) 2px 2px 4px 0px;
  display: block;
  position: absolute;
  content: "";
  width: 10px;
  height: 10px;
  bottom: -4px;
  background-color: #fff;
  left: 180px;
}

.lime-first-time-popup--top-left-standard_medium{
  left: -16px;
}

.lime-first-time-popup--top-left-standard_small{
  left: -20px;
}

.lime-first-time-popup--top-left-standard_large{
  left: -8px;
}

.lime-first-time-popup--left {
  border-bottom-right-radius: 12px !important;
}

.lime-first-time-popup .close-button {
  align-self: flex-start;
  line-height: 0.8rem;
  color: #595959;
  font-size: 20px;
  margin-bottom: 2px;
  cursor: pointer;
  -webkit-animation: chevron-rotate 1.2s cubic-bezier(0.18, 0.89, 0.32, 1.28);
  animation: chevron-rotate 1.2s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.lime-first-time-popup .close-button:hover{
  color: #000000;
  transform: scale(1.08)
}

.lime-first-time-popup .close-button:active{
  color: #000000;
  transform: scale(1)
}

.lime-first-time-popup .popup-image {
  height: 24px !important;
  width: 24px !important;
  border-radius: 100% !important;
  margin: 0 !important;
  box-shadow: unset;
  -webkit-animation: animate-image 5s ease-in-out infinite;
  animation: animate-image 5s ease-in-out infinite;
}

@keyframes widget-animation {
 0% {
    -webkit-transform: translateY(50px);
            transform: translateY(50px);
    opacity: 0.2;
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
  }
}

@keyframes animate-image {
  50% {
    transform: scale(1.1);
    box-shadow: 0 1px 5px  rgba(0, 0, 0, 0.2), 0 3px 4px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.14);
  }
}

@keyframes chevron-rotate {
  0%{
    transform: rotate(120deg);
    opacity: 0.2;
  }
  100%{
    transform: rotate(0);
    opacity: 1;
  }
}

@keyframes lime-fade-in-bottom {
  0% {
    -webkit-transform: translateY(50px);
            transform: translateY(50px);
    opacity: 0.2;
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
  }
}

@keyframes lime-fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
            transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
            transform: translateX(0);
    opacity: 1;
  }
}

@keyframes lime-fade-in-left {
  0% {
    -webkit-transform: translateX(-50px);
            transform: translateX(-50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
            transform: translateX(0);
    opacity: 1;
  }
}

.lime-unread-badge {
  position: absolute;
  border: 1px solid #d9d9d9;
  top: -8px;
  right: -8px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 24px;
  color: #fff !important;
  height: 24px;
  background: rgba(255, 66, 46, 1) !important;
  font-size: 12px !important;
  line-height: 20px !important;
}

.lime-unread-popup {
  display: flex;
  word-break: break-word;
  flex-direction: row;
  position: relative;
  align-items: flex-start !important;
  justify-content: center;
  background: white;
  max-width: 200px !important;
  min-width: 30px;
  cursor: pointer;
  box-sizing: border-box !important;
  margin-bottom: 8px;
  margin-left: 8px;
  box-shadow: 0px 0px 4px 0px rgb(0 0 0 / 20%);
  border-radius: 12px;
  font-size: 16px !important;
  line-height: 20px !important;
  padding: 8px !important;
  color: #434343 !important;
  font-weight: 400 !important;
}

.lime-unread-popup--right {
  margin-right: 8px;
  margin-left: unset !important;
}

.lime-unread-popup span {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.lime-unread-popup::before {
  content: '';
  position: absolute;
  visibility: visible;
  top: 90%;
  left: 7px !important;
  border: 8px solid transparent;
  border-top: 11px solid white;
  clear: both;
}

.lime-unread-popup--right::before {
  left: unset !important;
  right: 7px !important;
}

.lime-unread-popup--animate {
  -webkit-animation: scale-up-hor-left 0.4s ease-out both;
  animation: scale-up-hor-left 0.4s ease-out both;
}

@keyframes scale-up-hor-left {
  0% {
    -webkit-transform: scaleX(0);
            transform: scaleX(0);
    -webkit-transform-origin: 0% 0%;
            transform-origin: 0% 0%;
  }
  100% {
    -webkit-transform: scaleX(1);
            transform: scaleX(1);
    -webkit-transform-origin: 0% 0%;
            transform-origin: 0% 0%;
  }
}

.lime-banner-button, button.material-icons {
  background: none;
  border: 0px;
  color: inherit;
  font-style: inherit;
  font-variant: inherit;
  font-weight: inherit;
  font-stretch: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: normal;
  overflow: visible;
  padding: 0px;
  user-select: none;
  outline: none;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.lime--popup2 {
  background-size: cover;
  margin: 0px auto;
  padding: 50px 20px;
  border-radius: 0px;
  max-height: 42%;
  position: relative;
  text-align: center;
  top: 24% !important;
  position: fixed !important;
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 0px;
  left: 0;
}

#lime--popup1 {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

#lime--popup1 .lime--popup {
  margin: 0px auto;
  padding: 50px 20px;
  background: #fff;
  border-radius: 0px;
  min-height: 510px;
  max-width: 690px;
  position: relative;
  text-align: center;
  top: 50% !important;
  position: fixed !important;
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 0px;
  left: 0;
}

#lime--popup1 .lime--popup h2 {
  margin-top: 0;
  color: #333;
}

#lime--popup1 .lime--popup .close {
  position: absolute;
  top: 0px;
  right: 0px;
  transition: all 200ms;
  font-size: 30px;
  font-weight: normal;
  text-decoration: none;
  text-align: center;
  background: #333;
  border-radius: 0;
  cursor: pointer;
  float: right;
  padding: 0;
  color: #fff;
  margin-top: 0;
  margin-right: 0;
  height: 40px;
  width: 40px;
  line-height: 45px;
}

#lime--popup1 .lime--popup .close:hover {
  color: #06D85F;
}

#lime--dialog {
  margin-top: 49%;
}

#lime--popup1 .lime--popup .content {
  max-height: 30%;
  overflow: auto;
}

#lime--popup1 .newletter-title h2 {
  font-size: 24px;
  text-transform: uppercase;
  color: #000;
  font-weight: 700;
  letter-spacing: 3px;
  margin: 0 0 15px;
}

#lime--popup1 .box-content label {
  font-weight: 400;
  max-width: 560px;
  display: inline-block;
  margin-bottom: 5px;
  font-size: 14px;
  line-height: 26px;
}

.newletter-popup {
  background: #fff;
  top: 50% !important;
  position: fixed !important;
  padding: 0;
  text-align: center;
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

#lime--popup1 #frm_subscribe #subscribe_pemail {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  background: #EBEBEB none repeat scroll 0% 0%;
  border: medium none;
  height: 40px;
  width: 65%;
  margin: 20px 0;
  padding-left: 15px;
}

#lime--popup1 #frm_subscribe a {
  cursor: pointer;
  border: none;
  background: #333;
  padding: 3px 25px;
  text-transform: uppercase;
  font-size: 14px;
  color: #fff;
  font-weight: 600;
  line-height: 34px;
  display: inline-block;
  border-radius: 0;
  letter-spacing: 2px;
}

#lime--popup1 .box-content .subscribe-bottom {
  margin-top: 20px;
}

#lime--popup1 .box-content .subscribe-bottom #newsletter_popup_dont_show_again {
  display: inline-block;
  margin: 0;
  vertical-align: middle;
  margin-top: -1px;
}

#lime--popup1 .box-content .subscribe-bottom label {
  margin: 0;
  font-weight: 400;
  max-width: 650px;
  display: inline-block;
  margin-bottom: 5px;
  font-size: 12px;
}

#lime--popup1 *,
#lime--popup1 *:before,
#lime--popup1 *:after {
  -webkit-box-sizing: content-box !important;
  -moz-box-sizing: content-box !important;
  box-sizing: content-box !important;
}

@media screen and (min-width: 360px) and (max-height: 900px) and (orientation: portrait) {
  .lime--popup2 {
    background-size: cover;
    margin: 0px auto;
    padding: 0px 20px;
    border-radius: 0px;
    position: relative;
    height: 200px;
    width: 283px;
    text-align: center;
    top: 19% !important;
    position: fixed !important;
    -moz-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    right: 0px;
    left: 0;
  }
  #lime--popup1 .lime--popup {
    margin: 0px auto;
    padding: 0px 20px;
    background: #fff;
    border-radius: 0px;
    min-height: 450px;
    width: 282px;
    position: relative;
    text-align: center;
    top: 50% !important;
    position: fixed !important;
    -moz-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    right: 0px;
    left: 0;
  }
  #lime--dialog {
    margin-top: 81%;
  }
  #lime--popup1 .newletter-title h2 {
    font-size: 17px;
    text-transform: uppercase;
    color: #000;
    font-weight: 700;
    letter-spacing: 3px;
    margin: 0 0 15px;
  }
  #lime--popup1 .box-content label {
    font-weight: 400;
    max-width: 560px;
    display: inline-block;
    margin-bottom: 5px;
    font-size: 14px;
    line-height: 26px;
  }
  #lime--popup1 #frm_subscribe #subscribe_pemail {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    background: #EBEBEB none repeat scroll 0% 0%;
    border: medium none;
    height: 40px;
    width: 75%;
    margin: 20px 0;
    padding-left: 15px;
  }
  #lime--popup1 *,
  #lime--popup1 *:before,
  #lime--popup1 *:after {
    -webkit-box-sizing: content-box !important;
    -moz-box-sizing: content-box !important;
    box-sizing: content-box !important;
  }
}

@media screen and (min-width: 300px) and (max-height: 600px) and (orientation: portrait) {
  .lime--popup2 {
    background-size: cover;
    margin: 0px auto;
    padding: 7px 21px;
    border-radius: 0px;
    position: relative;
    height: 139px;
    width: 229px;
    text-align: center;
    top: 17% !important;
    position: fixed !important;
    -moz-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    right: 0px;
    left: 0;
  }
  #lime--popup1 .lime--popup {
    margin: 0px auto;
    padding: 0px 20px;
    background: #fff;
    border-radius: 0px;
    min-height: 357px;
    width: 229px;
    position: relative;
    text-align: center;
    top: 43% !important;
    position: fixed !important;
    -moz-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    right: 0px;
    left: 0;
  }
  #lime--dialog {
    margin-top: 81%;
  }
  #lime--popup1 .newletter-title h2 {
    font-size: 14px;
    text-transform: uppercase;
    color: #000;
    font-weight: 700;
    letter-spacing: 3px;
    margin: 0 0 15px;
  }
  #lime--popup1 .box-content label {
    font-weight: 400;
    max-width: 560px;
    display: inline-block;
    margin-bottom: 5px;
    font-size: 12px;
    line-height: 26px;
  }
  #lime--popup1 #frm_subscribe #subscribe_pemail {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    background: #EBEBEB none repeat scroll 0% 0%;
    border: medium none;
    height: 34px;
    width: 75%;
    margin: 8px 0;
    padding-left: 15px;
  }
  #lime--popup1 *,
  #lime--popup1 *:before,
  #lime--popup1 *:after {
    -webkit-box-sizing: content-box !important;
    -moz-box-sizing: content-box !important;
    box-sizing: content-box !important;
  }
}

@media only screen and (max-width: 667px) {
  .woot-widget-holder {
    height: 100%;
    right: 0;
    top: 0;
    width: 100%;
  }
  .woot-widget-bubble.woot--close {
    bottom: 60px;
    opacity: 0;
    visibility: hidden !important;
    z-index: -1 !important;
  }
}

@media screen and (min-width: 667px) and (max-height: 667px) {
  .woot-widget-holder {
    height: calc(100% - 32px) !important;
  }
}

@media only screen and (min-width: 667px) {
  .woot-widget-holder {
    border-radius: 8px !important;
    bottom: 16px;
    height: calc(85% - 64px - 16px);
    max-height: 590px !important;
    min-height: 250px !important;
    width: 400px !important;
  }
}`;
